import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCSuoCL_rejb-MCcTAjSqWgveghWxsRwY8",
  authDomain: "allta-pro.firebaseapp.com",
  projectId: "allta-pro",
  messagingSenderId: "1021311094536",
  appId: "1:1021311094536:web:e306cd735463c39c36a6bd",
  measurementId: "G-Z9CPM7Z49R"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
